// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {Text} from 'sail/Text';

type SubtitleProps = {|
  children: React.Node,
|};

export const Subtitle = ({children}: SubtitleProps) => (
  <Box padding={{top: 12}}>
    <Text size={24} weight="regular" lineHeight={28} display="block">
      {children}
    </Text>
  </Box>
);
